import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { deleteGood as deleteGoodActions } from '../actions';
import { DELETE_GOOD } from '../constants/actionTypes';
import { removeGood } from '../repository';


function *_deleteGood(action) {
    const {utrac, id} = action;
    yield put(loadDataAction('deleteGood'));

    try {
        yield call(removeGood(utrac, id));
        yield put(deleteGoodActions.success(id));
        yield put(loadDataSuccessAction('deleteGood', 'good.delete.success'));
    } catch (error) {
        yield put(deleteGoodActions.error(error));
        yield put(loadDataErrorAction('deleteGood', {response: error.response, body: error.body, titleId:'good.delete.failed'}, action));
    }

}


export function *deleteGood() {
    yield takeLatest(DELETE_GOOD.REQUEST, _deleteGood);
}